import { render, staticRenderFns } from "./SettlementFooter.vue?vue&type=template&id=0ab813b0&scoped=true&"
import script from "./SettlementFooter.vue?vue&type=script&lang=js&"
export * from "./SettlementFooter.vue?vue&type=script&lang=js&"
import style0 from "./SettlementFooter.vue?vue&type=style&index=0&id=0ab813b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab813b0",
  null
  
)

export default component.exports